import React, { useEffect } from 'react';
import { usePagination, DOTS } from './usePagination';

import './CustomPagination.scss';

const CustomPagination = (props) => {
  const {
    pageSize,
    totalCount,
    currentPage,
    onPageChange,
    className = '',
    siblingCount = 1,
    accessibilityPagination = false,
    accessibilityCurrentPage,
    setAccessibilityCurrentPage,
    hidePaginationNumbers,
  } = props;

  const paginationRange = usePagination({
    pageSize,
    totalCount,
    currentPage,
    siblingCount,
  });

  useEffect(() => {
    if (accessibilityCurrentPage === currentPage) {
      if (document.getElementById(`page-${accessibilityCurrentPage}`)) {
        document.getElementById(`page-${accessibilityCurrentPage}`).focus();
      }
    }
  }, [accessibilityCurrentPage, currentPage]);

  if (currentPage === 0 || paginationRange?.length < 2) {
    return null;
  }

  const onNext = () => {
    onPageChange(currentPage + 1);
    setAccessibilityCurrentPage(currentPage + 1);
  };

  const onPrevious = () => {
    onPageChange(currentPage - 1);
    setAccessibilityCurrentPage(currentPage - 1);
  };

  const lastPage = paginationRange
    ? paginationRange[paginationRange.length - 1]
    : 0;

  return (
    <ul className={`pagination-container-member ${className}`}>
      <li
        onClick={onPrevious}
        className={`pagination-item ${currentPage === 1 ? 'disabled' : ''}`}
      >
        <span
          className="arrow left"
          tabIndex={accessibilityPagination ? 0 : -1}
          aria-label={`${
            currentPage !== 1
              ? 'pagination, click to previous page.'
              : 'pagination previous button, disabled'
          }`}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && currentPage !== 1) {
              onPrevious();
            }
          }}
        />
      </li>

      {!hidePaginationNumbers &&
        paginationRange.map((pageNumber) => {
          if (pageNumber === DOTS)
            return (
              <li key={`id-${pageNumber}`} className="pagination-item dots">
                &#8230;
              </li>
            );

          return (
            <li
              key={`pagination-item-${pageNumber}`}
              onClick={() => {
                pageNumber !== currentPage ? onPageChange(pageNumber) : null;
                pageNumber !== currentPage
                  ? setAccessibilityCurrentPage(pageNumber)
                  : null;
              }}
              className={`pagination-item ${
                pageNumber === currentPage ? 'selected' : ''
              }`}
              //aria-current={pageNumber === currentPage ? true : false}
            >
              <span
                id={`page-${pageNumber}`}
                className="number"
                tabIndex={accessibilityPagination ? 0 : -1}
                role="button"
                aria-current={pageNumber === currentPage ? true : false}
                aria-label={
                  pageNumber !== currentPage
                    ? `click to open page number ${pageNumber}`
                    : `current page, page number  ${pageNumber}`
                }
                onKeyDown={(e) => {
                  if (e.key === 'Enter' && pageNumber !== currentPage) {
                    onPageChange(pageNumber);
                  }
                  if (e.key === 'Enter' && pageNumber !== currentPage) {
                    setAccessibilityCurrentPage(pageNumber);
                  }
                }}
              >
                {pageNumber}
              </span>
            </li>
          );
        })}

      <li
        onClick={onNext}
        className={`pagination-item ${
          currentPage === lastPage ? 'disabled' : ''
        }`}
      >
        <span
          tabIndex={accessibilityPagination ? 0 : -1}
          aria-label={`${
            currentPage !== lastPage
              ? 'pagination, click to next page'
              : 'pagination next button, disabled'
          }`}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && currentPage !== lastPage) {
              onNext();
            }
          }}
          className="arrow right"
        />
      </li>
    </ul>
  );
};

export default CustomPagination;
